import * as React from 'react';
import { Alert, Button, Col, Container, Form, Modal, Row } from 'react-bootstrap';
import { ReportAlias } from '../../../types/ReportAlias/ReportAlias';
import { Dispatch } from 'redux';
import axios, { AxiosError } from 'axios';

type DeleteAliasModalProps = {
    dispatch: Dispatch;
    reportAlias: ReportAlias | undefined;
    modalBody: any;
    okButton: any;
    hideModal: any;
    showModal: boolean;
}

interface DeleteAliasModalState {
    isLoading: boolean;
    validated: boolean;
    aliasId: string;
    hasError: boolean;
    errorMessage: string;
}

class DeleteAliasModal extends React.Component<DeleteAliasModalProps, DeleteAliasModalState> {
    public constructor(props: DeleteAliasModalProps) {
        super(props);
        this.state = {
            isLoading: false,
            validated: false,
            aliasId: '',
            hasError: false,
            errorMessage: '',
        }
    }

    private handleDeleteAliasModalOkButton() {
        this.resetState();

        axios
        .delete<ReportAlias>(`./api/reports/${this.props.reportAlias?.reportId}/aliases/${this.props.reportAlias?.id}`)
        .then((response: { data: ReportAlias; }) => {
            const { data } = response;
                this.props.okButton();
        })
        .catch((e: AxiosError) => {
            let errorMessage = e.response?.data ? e.response?.data : e.message;

            this.setState({validated: false}); 
            this.setState({errorMessage: errorMessage});
            this.setState({hasError: true});
        });
    }

    private handleCloseModal() {
        this.resetState();
        this.props.hideModal();
    }

    // Reset the modal state to default
    private resetState() {
        this.setState({
            errorMessage: "",
            hasError: false,
        });
        this.setState({validated: false});
    }

    public render() {

        return(
            <Modal show={this.props.showModal} onHide={() => this.handleCloseModal()}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Delete Alias
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <Col>
                                <Alert variant='danger' show={this.state.hasError ? true : false}>
                                    {this.state.errorMessage}
                                </Alert>
                            </Col>
                        </Row>
                        <Row>
                            {this.props.modalBody}
                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.handleCloseModal()}>
                        Close
                    </Button>
                    <Button
                        variant="danger"
                        disabled={this.state.isLoading}
                        onClick={() => this.handleDeleteAliasModalOkButton()}
                    >
                        {this.state.isLoading ? 'Loading...' : 'Delete Alias'}
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default DeleteAliasModal;
